/*
 * @Author: your name
 * @Date: 2021-07-19 16:36:02
 * @LastEditTime: 2021-08-02 15:11:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\api\settlement.js
 */
import request from '../../utils/request'

// 结算审核 获取待结算列表
export function queryList(params) {
  return request({
    url: '/order/eshop/tas/settlement/queryList',
    method: 'get',
    params
  })
}

// 结算审核 获取待结算列表-总计
export function querySettTotal(params) {
  return request({
    url: '/order/eshop/tas/settlement/querySettTotal',
    method: 'get',
    params
  })
}

// 结算审核 获取待结算列表-总计-系统外总部
export function queryHeadQuarterOutsideSettTotal(params) {
  return request({
    url: '/order/eshop/tas/settlement/queryHeadQuarterOutsideSettTotal',
    method: 'get',
    params
  })
}

// 结算审核 获取待结算列表-系统外门店- 总计
export function queryOutsideSettTotal(params) {
  return request({
    url: '/order/eshop/tas/settlement/queryOutsideSettTotal',
    method: 'get',
    params
  })
}




// 结算审核 获取待结算列表
export function queryOrderList(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryOrderList',
    method: 'post',
    data
  })
}
// 结算审核 获取待结算列表总计
export function queryOrderTotal(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryOrderTotal',
    method: 'post',
    data
  })
}


// 预览结算单 获取账户接口
export function querySettlementAccountList(params) {
  return request({
    url: '/settlement/eshop/settlement/querySettlementAccountBankInfo',
    method: 'get',
    params
  })
}

// 结算记录  2.SRM向TAS申请了结算
export function getSettlementPage(data) {
    return request({
      url: '/settlement/eshop/tassettlement/getSettlementPage',
      method: 'post',
      data
    })
  }

//结算记录操作日志
export function getSettlementLogPage(data) {
  return request({
    url: '/settlement/eshop/settlement/getSettlementLogPage',
    method: 'post',
    data
  })
}

// 结算记录总计
export function getSettStatistics(data) {
  return request({
    url: '/settlement/eshop/tassettlement/getSettStatistics',
    method: 'post',
    data
  })
}

// 作废结算单
export function cancelSett(params) {
  return request({
    url: '/settlement/eshop/tassettlement/cancelSett',
    method: 'get',
    params
  })
}

// 申请结算
export function applySett(params) {
  return request({
    url: '/settlement/eshop/tassettlement/applySett',
    method: 'get',
    params
  })
}

  // 获取当前登录人信息
  export function currentUser(params) {
    return request({
      url: '/auth/account/currentUser',
      method: 'get',
      params
    })
  }

  // 待对账结算  对账或驳回
  
  export function reconciliation(data) {
    return request({
      url: '/settlement/eshop/tassettlement/reconciliation',
      method: 'post',
      data
    })
  }

  // 修改结算账户
 
  export function editSettAccount(data) {
    return request({
      url: '/settlement/eshop/tassettlement/editSettAccount',
      method: 'post',
      data
    })
  }

  // 根据结算单号获取结算详情
  export function getSettInfo(params) {
    return request({
      url: '/settlement/eshop/tassettlement/getSettInfo',
      method: 'get',
      params
    })
  }

  // 
  export function checkSettlementOrderType(data) {
    return request({
      url: '/order/eshop/srm/settlement/checkSettlementOrderType',
      method: 'post',
      data
    })
  }

  // 生成结算单
  
  export function generateSett(data) {
    return request({
      url: '/settlement/eshop/tassettlement/generateSett',
      method: 'post',
      data
    })
  }

  // 关闭异常结算单
  export function applyCloseSett(data) {
    return request({
      url: '/settlement/eshop/tassettlement/applyCloseSett',
      method: 'post',
      data
    })
  }


  // 首页代办
  export function MyToDoList(data) {
    return request({
      url: '/auth/personal/MyToDoList',
      method: 'post',
      data
    })
  }

  // 待对账结算
  
  export function queryWaitReconciliationSettlement(params) {
    return request({
      url: '/settlement/eshop/tassettlement/queryWaitReconciliationSettlement',
      method: 'get',
      params
    })
  }
  // 代付款
  
  export function queryWaitPay(params) {
    return request({
      url: '/settlement/eshop/tassettlement/queryWaitPay',
      method: 'get',
      params
    })
  }
  // 待确认关闭异常结算单
  export function queryWaitConfirmCloseAbnormalSettlementOrder(params) {
    return request({
      url: '/settlement/eshop/tassettlement/queryWaitConfirmCloseAbnormalSettlementOrder',
      method: 'get',
      params
    })
  }

  // 待确认
  export function getToBeConfirmOrder(params) {
    return request({
      url: '/order/eshop/tas/order/getToBeConfirmOrder',
      method: 'get',
      params
    })
  }
  // 代付定金
  
  export function getReplaceDepositPayment(params) {
    return request({
      url: '/order/eshop/tas/order/getReplaceDepositPayment',
      method: 'get',
      params
    })
  }

  // 待处理变更
  
  export function getWaitApplyConfirmOrder(params) {
    return request({
      url: '/order/eshop/tas/order/getWaitApplyConfirmOrder',
      method: 'get',
      params
    })
  }
  
  // 待处理取消
  
  export function getWaitCancelOrder(params) {
    return request({
      url: '/order/eshop/tas/order/getWaitCancelOrder',
      method: 'get',
      params
    })
  }
//  待店长处理异常变更/取消

export function queryWaitAdminHandleAbnormalChangeOrCancel(params) {
  return request({
    url: '/order/eshop/tas/order/queryWaitAdminHandleAbnormalChangeOrCancel',
    method: 'get',
    params
  })
}

//  待转正订单

export function queryWaitRegularOrder(params) {
  return request({
    url: '/order/eshop/tas/order/queryWaitRegularOrder',
    method: 'get',
    params
  })
}
// 待发送合同

export function queryWaitSendContract(params) {
  return request({
    url: '/order/eshop/tas/order/queryWaitSendContract',
    method: 'get',
    params
  })
}

// 特殊投保订单

export function querySpecialInsureOrder(params) {
  return request({
    url: '/order/eshop/tas/order/querySpecialInsureOrder',
    method: 'get',
    params
  })
}
// 待店长处理异常变更/取消

export function getWaitLeaderConfirmOrder(params) {
  return request({
    url: '/order/eshop/tas/order/getWaitLeaderConfirmOrder',
    method: 'get',
    params
  })
}

// 业务告警数量
export function queryThreeDaysAlarmCount(params) {
  return request({
    url: '/message/alarmInfo/queryThreeDaysAlarmCount',
    method: 'get',
    params
  })
}

// 业务告警列表

export function queryAlarmList(data) {
  return request({
    url: '/message/alarmInfo/queryAlarmList',
    method: 'post',
    data
  })
}

// 查询警告详情

export function queryAlarmInfo(params) {
  return request({
    url: '/message/alarmInfo/queryAlarmInfo',
    method: 'get',
    params
  })
}
// 待审核充值
export function getBacklogInfo(params) {
  return request({
    url: '/capital/eshop/capital-flow/getBacklogInfo',
    method: 'get',
    params
  })
}
// 业务告警全部已读
export function batchRead(data) {
  return request({
    url: '/message/alarmInfo/batchRead',
    method: 'post',
    data
  })
}
// 获取系统外供应商待结算列表
export function queryOutsideList(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryOutsideList',
    method: 'get',
    params:data
  })
}
// 获取系统外待结算订单列表
export function queryOutSideOrderList(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryOutSideOrderList',
    method: 'post',
    data
  })
}
// 获取系统外待结算订单列表-总计
export function queryOutSideOrderTotal(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryOutSideOrderTotal',
    method: 'post',
    data
  })
}
// 获取系统外供应商待结算列表-总部
export function queryHeadQuarterOutsideList(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryHeadQuarterOutsideList',
    method: 'get',
    params:data
  })
}
// 获取系统外待结算订单列表-总部
export function queryHeadQuarterOutSideOrderList(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryHeadQuarterOutSideOrderList',
    method: 'post',
    data
  })
}
// 获取系统外待结算订单列表-总计-总部
export function queryHeadQuarterOutSideOrderTotal(data) {
  return request({
    url: '/order/eshop/tas/settlement/queryHeadQuarterOutSideOrderTotal',
    method: 'post',
    data
  })
}

// 获取系统外待结算订单记录列表-总计-总部
export function getHeadQuarterSettlementPage(data) {
  return request({
    url: '/settlement/eshop/tassettlement/getHeadQuarterSettlementPage',
    method: 'post',
    data
  })
}

// 待对账结算  对账或驳回 -系统外订单/总部特许经营  
export function reconciliationByHeadQuarterOutSide(data) {
  return request({
    url: '/settlement/eshop/tassettlement/reconciliationByHeadQuarterOutSide',
    method: 'post',
    data
  })
}

// 总部结算付款
export function settPayByHeadQuarter(data) {
  return request({
    url: '/settlement/eshop/tassettlement/settPayByHeadQuarter',
    method: 'post',
    data
  })
}

// 总部结算 保存最后一次调增调减
export function saveCostChangeData(data) {
  return request({
    url: '/settlement/eshop/settlement/saveCostChangeData',
    method: 'post',
    data
  })
}

// 总部结算 获取最后一次调增调减
export function getCostChangeData(data) {
  return request({
    url: '/settlement/eshop/settlement/getCostChangeData',
    method: 'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/TASMini/api/settlement.js